import { convertNumber, toCurrency } from 'src/utils/number';

export const NORMALIZED_DELAY_SLUG = 'NORMALIZED_DELAY';

export function formatWalletColumnValue(slug, value, format = 'csv') {
  if (slug === NORMALIZED_DELAY_SLUG) {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) return 'N/D';

    return `${convertNumber(numericValue * 100, 2, 2)}%`;
  }

  if (format === 'table') {
    return toCurrency(value);
  }

  return convertNumber(value, 2);
}

export function buildWalletCsvRows(rows, periods) {
  return periods.map((period) => {
    const periodIndex = periods.findIndex((p) => p === period);
    const parsedColumns = rows.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.slug]: formatWalletColumnValue(
          curr.slug,
          curr?.data[periodIndex],
          'csv',
        ),
      }),
      {},
    );

    return {
      date: period,
      ...parsedColumns,
    };
  });
}

export function getWalletCsvOptions(name, headers) {
  return {
    fieldSeparator: ',',
    quoteStrings: '"',
    showLabels: true,
    filename: `${name}_carteira`,
    headers,
  };
}
